const translations = {
    detach: 'Remove prescription',
    errorParseFailed: 'Could not read shapefile: {{message}}',
    errorServerRejected: 'Prescription rejected: {{message}}',
    gapPolicyBaseRate: 'Use base rate',
    gapPolicyLabel: 'Gap policy',
    gapPolicyMask: 'Skip gaps',
    legendTitle: 'Rate legend',
    legendZoneMask: 'Single rate',
    rateColumnConfirm: 'Use this column',
    rateColumnHint: 'Choose the .dbf column that holds the application rate.',
    rateColumnLabel: 'Rate column',
    title: 'Prescription',
    uploadHint: 'Upload .shp + .shx + .dbf + .prj or a single .zip',
    uploadProcessing: 'Reading shapefile...',
    warningCancel: 'Cancel',
    warningConfirm: 'Continue',
    warningInvalidPolygons: '{{count}} polygons are invalid and cannot be used.',
    warningTitle: 'Shapefile cannot be used',
    warningUnsupportedCrs: 'CRS "{{crs}}" is not supported. Reproject to WGS84 first.',
    zoneCount: '{{count}} zones loaded'
};

export default translations;
